import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Axios from "axios";
import vuetify from './plugins/vuetify'
import "@/assets/main.scss";

import common from './common'

Vue.mixin(common)

// import VueApexCharts from 'vue-apexcharts'
// Vue.use(VueApexCharts)
// Vue.component('apexchart', VueApexCharts)
import Toast from "vue-toastification";
// Import the CSS.
import "vue-toastification/dist/index.css";
import QuillEditor from 'vue-quill-editor'
Vue.use(QuillEditor);

import VueEllipseProgress from 'vue-ellipse-progress';

Vue.use(VueEllipseProgress);

const options = {
    position: 'top-right',
    timeout: 3000
};
Vue.use(Toast, options);

import lottie from 'lottie-web';
import { defineElement } from 'lord-icon-element';
defineElement(lottie.loadAnimation);
Vue.config.productionTip = false

Vue.prototype.$http = Axios;
const token = localStorage.getItem("access_token");
if (token) {
  Vue.prototype.$http.defaults.headers.common["Authorization"] = token;
}
// ────────────────────────────────────────────────
// 401 bo'lganda avto-logout qilish uchun INTERCEPTOR
// ────────────────────────────────────────────────
Axios.interceptors.response.use(
  (response) => { return response },
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("access_token");
      // if (store) { store.dispatch("auth/logout") }
      router.push("/login");
      Vue.prototype.$toast.error("Sessiya tugadi. Iltimos, qayta kirishni amalga oshiring.");
    }
    return Promise.reject(error);
  }
);

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
